export const INFLATION_PERCENT = 5;
